import { render } from "./TitleDescription.vue?vue&type=template&id=1bc9973f"
import script from "./TitleDescription.vue?vue&type=script&lang=js"
export * from "./TitleDescription.vue?vue&type=script&lang=js"
script.render = render

export default script